export const reportsColumns = [


    {
        field: "testName",
        headerName: "Test Name",
        width: 350,
    },
    {
        field: "testCode",
        headerName: "Test Code",
        width: 300,
    },
    {
        field: "departmentName",
        headerName: "Department Name",
        width: 230,
    },

    {
        field: "price",
        headerName: "Price",
        width: 200,
    },


];
